import axios from 'axios';
import type { User, ApiResponse } from '@/types';

const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3001';
const authAxios = axios.create({ baseURL: `${API_URL}/api/auth` });

export const authApi = {
  login: async (identifier: string, password: string) => {
    const { data } = await authAxios.post<ApiResponse<{ requiresOTP: boolean; userId?: string; accessToken?: string; refreshToken?: string; user?: User }>>('/login', { identifier, password });
    return data.data!;
  },

  requestOTP: async (identifier: string, channel: 'sms' | 'whatsapp' = 'sms') => {
    const { data } = await authAxios.post('/otp/request', { identifier, channel });
    return data;
  },

  verifyOTP: async (identifier: string, otp: string) => {
    const { data } = await authAxios.post<ApiResponse<{ accessToken: string; refreshToken: string; user: User }>>('/otp/verify', { identifier, otp });
    return data.data!;
  },

  refresh: async (refreshToken: string) => {
    const { data } = await authAxios.post<ApiResponse<{ accessToken: string }>>('/refresh', { refreshToken });
    return data.data!;
  },

  logout: async (accessToken: string) => {
    await authAxios.post('/logout', {}, { headers: { Authorization: `Bearer ${accessToken}` } });
  },

  me: async (accessToken: string): Promise<User> => {
    const { data } = await authAxios.get<ApiResponse<{ user: User }>>('/me', { headers: { Authorization: `Bearer ${accessToken}` } });
    return data.data!.user;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const { data } = await authAxios.post('/password/change', { currentPassword, newPassword });
    return data;
  },
};
